'use client'

import {
  type V3HistoryTransaction,
  getUserV3History,
} from '@sushiswap/graph-client/data-api'
import { SkeletonCircle, SkeletonText } from '@sushiswap/ui'
import { useQuery } from '@tanstack/react-query'
import type { Address } from 'viem'
import { useConnection } from 'wagmi'
import { PortfolioHistoryTransaction } from './portfolio-history-transaction'

function usePortfolioHistory(address: Address | undefined) {
  return useQuery<V3HistoryTransaction[]>({
    queryKey: ['portfolio-history-v3', address],
    queryFn: async () => getUserV3History({ address: address as string }),
    enabled: !!address,
    refetchInterval: 60_000,
  })
}

export const PortfolioHistory = () => {
  const { address } = useConnection()
  const { data, isLoading } = usePortfolioHistory(address)

  return (
    <div className="flex flex-col gap-y-5 h-full overflow-hidden">
      <div className="overflow-y-auto h-full cursor-default">
        {isLoading ? (
          <div>
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={`${i}`}
                className="flex w-full items-center px-5 py-3 gap-x-5"
              >
                <SkeletonCircle radius={28} />
                <div className="flex w-full justify-between items-center gap-x-3">
                  <div className="basis-3/4 flex flex-col gap-y-1">
                    <SkeletonText fontSize="sm" />
                    <SkeletonText fontSize="xs" />
                  </div>
                  <div className="basis-1/4 flex flex-col gap-y-1">
                    <SkeletonText fontSize="sm" />
                    <SkeletonText fontSize="xs" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : data?.length ? (
          data.map((tx) => <PortfolioHistoryTransaction key={tx.id} tx={tx} />)
        ) : (
          <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
            No activity found
          </div>
        )}
      </div>
    </div>
  )
}
